import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as classNames from 'classnames';
import * as moment from 'moment';
import { IconButton } from 'components/action';
import { SavingIndicator, SavingIndicatorStatus } from 'components/indicator';
import { DatePickerDropdown } from 'components/calendar';
import { StatusOfBusinessPartner } from 'common/interfaces/businessPartner';
import { IAppStore } from 'stores/AllStores';
import { SectionHeadline } from 'components/content';

// Enumerables
export enum BusinessPartnerProperties {
  shippingAddress1 = 'shippingAddress1',
  shippingAddress2 = 'shippingAddress2',
  shippingCity = 'shippingCity',
  shippingState = 'shippingState',
  shippingZipcode = 'shippingZipcode',
  licenceNumber = 'licenceNumber',
  licenceExp = 'licenceExp',
}

// Styles
const s = require('./BusinessPartnerContent.css');
const addIcon = require('assets/plus icon.svg');

// Props
interface IBusinessPartnerContentProps {
  store?: IAppStore;
  status: StatusOfBusinessPartner;
}

// Component
@inject('store')
@observer
export class BusinessPartnerContent extends React.Component<
  IBusinessPartnerContentProps,
  {}
> {
  static get defaultProps(): IBusinessPartnerContentProps {
    return {
      status: StatusOfBusinessPartner.None,
    };
  }

  constructor(props: IBusinessPartnerContentProps) {
    super(props);

    document.documentElement.style.overflow = 'hidden';
  }

  public componentWillUnmount() {
    document.documentElement.style.overflow = null;
  }

  public render() {
    const { newRequest } = this.props.store.businessPartner;

    return (
      <div>
        <div className={s.copyAddress}>
          <IconButton
            className={s.copyIcon}
            onClick={this.props.store.businessPartner.copyShippingAddress}
            label="Copy address from lead's details"
            showLabel={true}
            labelOnRight={false}
            icon={addIcon}
          />
        </div>

        <div className={classNames(s.fields, s.address)}>
          <SectionHeadline title="Physical / shipping address" />

          <div className={s.group}>
            <label>
              <p>
                <span>Address 1</span>
              </p>

              <input
                type="text"
                value={newRequest.shippingAddress1}
                onChange={this.handleBusinessPartnerDetailsChange(
                  BusinessPartnerProperties.shippingAddress1
                )}
              />
            </label>

            <label>
              <p>
                <span>Address 2</span>
              </p>

              <input
                type="text"
                value={newRequest.shippingAddress2}
                onChange={this.handleBusinessPartnerDetailsChange(
                  BusinessPartnerProperties.shippingAddress2
                )}
              />
            </label>

            <label>
              <p>
                <span>City</span>
              </p>

              <input
                type="text"
                value={newRequest.shippingCity}
                onChange={this.handleBusinessPartnerDetailsChange(
                  BusinessPartnerProperties.shippingCity
                )}
              />
            </label>

            <label>
              <p>
                <span>State</span>
              </p>

              <input
                type="text"
                value={newRequest.shippingState}
                onChange={this.handleBusinessPartnerDetailsChange(
                  BusinessPartnerProperties.shippingState
                )}
              />
            </label>

            <label>
              <p>
                <span>ZIP code</span>
              </p>

              <input
                type="text"
                value={newRequest.shippingZipcode}
                onChange={this.handleBusinessPartnerDetailsChange(
                  BusinessPartnerProperties.shippingZipcode
                )}
              />
            </label>
          </div>
        </div>

        <div className={classNames(s.fields, s.license)}>
          <SectionHeadline title="License" />

          <div className={s.group}>
            <label>
              <p>
                <span>License number</span>
              </p>

              <input
                type="text"
                value={newRequest.licenceNumber}
                onChange={this.handleLicenseNumberChange}
              />
            </label>

            <div className={s.licenseExp}>
              <DatePickerDropdown
                onChange={this.handleLicenseExpirationDateChange}
                value={newRequest.licenceExp.date}
                label="License expiration"
              />
            </div>
          </div>
        </div>

        <div className={s.footer}>
          <SavingIndicator
            align="right"
            labels={{
              saving: 'Saving...',
              error:
                newRequest.status ===
                StatusOfBusinessPartner.ErrorCustomerAlreadyCreated
                  ? 'Lead has already been promoted to business partner, reload lead'
                  : 'Could not submit, try again',
              success: newRequest.promoted,
            }}
            status={
              newRequest.status === StatusOfBusinessPartner.Saving
                ? SavingIndicatorStatus.Saving
                : newRequest.status === StatusOfBusinessPartner.ErrorTryAgain ||
                  newRequest.status ===
                    StatusOfBusinessPartner.ErrorCustomerAlreadyCreated
                ? SavingIndicatorStatus.Error
                : newRequest.status === StatusOfBusinessPartner.Success
                ? SavingIndicatorStatus.Success
                : SavingIndicatorStatus.None
            }
          />

          <button className="boxButton" onClick={this.handleSubmit}>
            Make a business partner
          </button>
        </div>
      </div>
    );
  }

  private handleBusinessPartnerDetailsChange = (
    property: BusinessPartnerProperties
  ) => (e: React.FormEvent<HTMLInputElement>) => {
    if (
      typeof this.props.store.businessPartner.newRequest[property] === 'string'
    ) {
      // @ts-ignore
      this.props.store.businessPartner.newRequest[property] =
        e.currentTarget.value;
    }
  };

  private handleLicenseNumberChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.props.store.businessPartner.newRequest.licenceNumber =
      e.currentTarget.value;
  };

  private handleLicenseExpirationDateChange = (date: moment.Moment) => {
    this.props.store.businessPartner.changeLicenseExpirationDate(date);
  };

  private handleSubmit = () => {
    this.props.store.businessPartner.createBusinessPartner();
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/BusinessPartner/Modal/BusinessPartnerContent.tsx